import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
import {
  entityReducer,
  menuReducer,
  viewInfoReducer,
  blockReducer,
  paragraphReducer,
  taxonomyReducer,
  uiReducer,
  loginReducer,
  commentReducer,
} from '@uncinc/react-drupal-core';

import uiInternal from './UI';
import debug from './Debug';
import registrationsReducer from './Registrations';
import customNodeReducer from './Entity/Node';
import customUserReducer from './Entity/User';
import customViewReducer from './Entity/View';
import customWebformReducer from './Webform';
import exerciseSubmissionsReducer from './ExerciseSubmissions';
import nursePractitionerReducer from './NursePractitioner';
import messagesReducer from './Messages';
import notificationReducer from './Notification';

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  debug,
  entity: entityReducer,
  menu: menuReducer,
  node: customNodeReducer,
  webform: customWebformReducer,
  block: blockReducer,
  paragraph: paragraphReducer,
  view: customViewReducer,
  viewInfo: viewInfoReducer,
  taxonomyTerm: taxonomyReducer,
  ui: uiReducer,
  uiInternal: uiInternal,
  login: loginReducer,
  user: customUserReducer,
  registrations: registrationsReducer,
  exerciseSubmissions: exerciseSubmissionsReducer,
  nursePractitioner: nursePractitionerReducer,
  messages: messagesReducer,
  notification: notificationReducer,
  comment: commentReducer,
});

export default rootReducer;
